import { AccountContact } from "../api/services";

export const formatContactName = (contact: AccountContact) => {
  return contact.forename || contact.surname
    ? [contact.title, contact.forename, contact.surname]
        .filter((a) => !!a) //Exclude missing values
        .join(" ")
    : "Contact name";
};
